import { useState, useEffect, useCallback } from 'react';
import { GetSingleOneTimeNotification } from '../apis/shipment';
import type { ApiResponse, SingleShipmentDataExtended } from '../apis/types';
import useUnauthorize from './useUnauthorize';
import { useToken } from '../common/helper';

interface UseFetchSingleOneTimeReturn {
  oneTimeData: unknown;
  refetchShipment: () => void;
}

const useFetchSingleOneTime = (
  notificationId: string
): UseFetchSingleOneTimeReturn => {
  const { checkTokenExpiry } = useToken();
  const { unauthorize } = useUnauthorize();

  const [oneTimeData, setOneTimeData] =
    useState<SingleShipmentDataExtended | null>(null);

  const fetchSingleOneTime = useCallback(() => {
    if (!notificationId) {
      return;
    }
    const token = checkTokenExpiry();
    if (!token) {
      return;
    }

    GetSingleOneTimeNotification(token, notificationId)
      .then((res: ApiResponse) => {
        const data = res?.data?.data;
        if (data?.is_success && data?.data) {
          const resp = data.data as SingleShipmentDataExtended;
          setOneTimeData(resp);
        } else {
          setOneTimeData(null);
        }
      })
      .catch((error) => {
        unauthorize(error);
        setOneTimeData(null);
      });
  }, [checkTokenExpiry, unauthorize, notificationId]);

  useEffect(() => {
    fetchSingleOneTime();
  }, [fetchSingleOneTime]);

  return { oneTimeData, refetchShipment: fetchSingleOneTime };
};

export default useFetchSingleOneTime;
